import {
  // -- GET (list)
  GET_PROJECT_WEATHERS_SUCCESS,
  GET_PROJECT_WEATHERS_FAILURE,
  // -- CREATE
  CREATE_PROJECT_WEATHER_SUCCESS,
  CREATE_PROJECT_WEATHER_FAILURE,
  // -- UPDATE
  UPDATE_PROJECT_WEATHER_SUCCESS,
  UPDATE_PROJECT_WEATHER_FAILURE,
  // -- DELETE
  DELETE_PROJECT_WEATHER_SUCCESS,
  DELETE_PROJECT_WEATHER_FAILURE,
  // -- SEARCH
  SEARCH_PROJECT_WEATHERS
} from '../../../actions'
import { Logger, LoggerTypes } from '../../../utils'

let cacheItems = null

export const projectWeathers = (state = {}, action) => {
  switch (action.type) {
    // -- GET PROJECT WEATHERS (list)
    case GET_PROJECT_WEATHERS_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectWeathers.GET_PROJECT_WEATHERS_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_PROJECT_WEATHERS_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectWeathers.GET_PROJECT_WEATHERS_SUCCESS()', { state, action })
      return {
        ...state,
        items: action.data
      }
    }

    // -- CREATE PROJECT WEATHER
    case CREATE_PROJECT_WEATHER_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectWeathers.CREATE_PROJECT_WEATHER_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case CREATE_PROJECT_WEATHER_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectWeathers.CREATE_PROJECT_WEATHER_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE PROJECT WEATHER
    case UPDATE_PROJECT_WEATHER_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectWeathers.UPDATE_PROJECT_WEATHER_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case UPDATE_PROJECT_WEATHER_SUCCESS: {
      const items = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectWeathers.UPDATE_PROJECT_WEATHER_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- DELETE PROJECT WEATHER
    case DELETE_PROJECT_WEATHER_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectWeathers.DELETE_PROJECT_WEATHER_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case DELETE_PROJECT_WEATHER_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectWeathers.DELETE_PROJECT_WEATHER_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- SEARCH PROJECT
    case SEARCH_PROJECT_WEATHERS: {
      const txt = action.data || ''
      if (txt.length <= 1 && cacheItems === null && state.items) {
        cacheItems = [...state.items]
      }

      const escapeRegExp = (value) => value && value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
      const searchRegex = new RegExp(escapeRegExp(txt), 'i')
      const searchItems = (cacheItems || []).filter((row) =>
        Object.keys(row).some((field) => searchRegex.test(((row && row[field]) || '').toString()))
      )
      return {
        ...state,
        items: searchItems
      }
    }

    default:
      return state
  }
}
